import { breakpoints } from 'config/config';
import styled from 'styled-components';

export const StyledFileUploader = styled.div`
  .file-uploader-label {
    padding-bottom: 8px;
  }

  && .ant-upload-wrapper .ant-upload-drag {
    border: 2px dashed ${(props) => props.theme.imageBorder};
    border-radius: 8px;
    padding: 20px 20px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      border-color: ${(props) => props.theme.black};
    }

    &.ant-upload-disabled {
      cursor: not-allowed;
      opacity: 0.6;
      border-color: ${(props) => props.theme.lightGrey};

      &:hover {
        border-color: ${(props) => props.theme.lightGrey};
      }

      .ant-upload-drag-icon .anticon {
        color: ${(props) => props.theme.lightGrey};
      }

      label {
        color: ${(props) => props.theme.grey};
      }
    }

    .ant-upload-drag-icon {
      margin-bottom: 16px;

      .anticon {
        font-size: 48px;
        color: ${(props) => props.theme.lightGrey};
      }
    }

    label {
      display: block;
      font-size: 16px;
      color: ${(props) => props.theme.lightGrey};
      margin: 0 0 8px 0;
      line-height: 1.4;
      cursor: inherit;

      &.regular {
        font-size: 14px;
        color: ${(props) => props.theme.grey};
      }

      &.theme-color {
        color: ${(props) => props.theme.colorPrimary};
      }
    }
  }

  .ant-upload-list {
    margin-top: 12px;
  }

  .ant-upload-list-item {
    border: 1px solid ${(props) => props.theme.colorBorder};
    border-radius: 6px;
    padding: 8px 12px;
    margin-bottom: 8px;
    background: ${(props) => props.theme.white};

    &:hover {
      border-color: ${(props) => props.theme.colorPrimary};
    }
  }

  .ant-upload-list-item-name {
    color: ${(props) => props.theme.colorText};
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .ant-upload-list-item-actions {
    .anticon {
      color: ${(props) => props.theme.grey};

      &:hover {
        color: ${(props) => props.theme.colorPrimary};
      }
    }
  }

  .custom-file-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    border: 1px solid ${(props) => props.theme.colorBorder};
    border-radius: 8px;
    margin-bottom: 8px;
    background: ${(props) => props.theme.white};
    transition: all 0.3s ease;

    &:hover {
      border-color: ${(props) => props.theme.colorPrimary};
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    .file-info {
      display: flex;
      align-items: center;
      gap: 12px;
      flex: 1;
      min-width: 0;

      .anticon {
        font-size: 20px;
        color: ${(props) => props.theme.colorPrimary};
        flex-shrink: 0;
      }

      .file-name {
        font-weight: 500;
        color: ${(props) => props.theme.colorText};
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        flex: 1;
        min-width: 0;
      }

      .file-size {
        color: ${(props) => props.theme.grey};
        font-size: 12px;
        flex-shrink: 0;
      }
    }

    .file-actions {
      display: flex;
      gap: 8px;
      flex-shrink: 0;

      .ant-btn {
        height: 28px;
        padding: 4px 8px;
        border-radius: 4px;
        border: 1px solid ${(props) => props.theme.colorBorder};
        background: ${(props) => props.theme.white};
        color: ${(props) => props.theme.grey};
        transition: all 0.3s ease;

        &:hover {
          border-color: ${(props) => props.theme.colorPrimary};
          color: ${(props) => props.theme.colorPrimary};
        }

        &.ant-btn-icon-only {
          width: 28px;
          padding: 0;
        }
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .ant-upload-drag-container {
      label {
        font-size: 1rem !important;
      }
    }
  }
`;
